// extracted by mini-css-extract-plugin
export default {"cardSpotlight":"CardSpotlight_cardSpotlight__C1bvq","spotlight":"CardSpotlight_spotlight__USisj"};